<template>
  <div>

    <info-and-auth-bar />

    <!-- tabs -->
    <ul class="tab tab-block select-none">
      <li v-for="item in MENU_OPTIONS" :class="selected === item ? 'active' : null" class="tab-item">
        <a @click="selected = item">{{ item }}</a>
      </li>
    </ul>

    <!-- actual content -->
    <div class="p-8">

      <!-- quiz templates -->
      <div v-if="selected === MENU_OPTIONS.QUIZ_TEMPLATES" class="grid grid-cols-3 gap-8">
        <quiz-card v-for="quiz in quizTemplates" :quiz="quiz" />

        <!-- add quiz template -->
        <button class="block border-dashed border-4 border-gray-100 flex justify-center items-center"
                @click="createQuizTemplate">
          <span class="text-xl font-semibold my-4">Quizvorlage erstellen</span>
        </button>
      </div>

      <!-- quizzes -->
      <div v-if="selected === MENU_OPTIONS.QUIZZES" class="grid grid-cols-3 gap-8">
        <quiz-card v-for="quiz in quizzes" :quiz="quiz" />
      </div>

      <!-- trashed quizzes -->
      <div v-if="selected === MENU_OPTIONS.TRASH" class="grid grid-cols-3 gap-8">
        <quiz-card v-for="quiz in trashedQuizzes" :quiz="quiz" />
      </div>

      <mediathek v-if="selected === MENU_OPTIONS.MEDIA" />

      <settings v-if="selected === MENU_OPTIONS.SETTINGS" />

    </div>


  </div>
</template>
<script>
import QuizCard from "../components/dashboard/QuizCard";
import Mediathek from "../components/dashboard/Mediathek";
import InfoAndAuthBar from "../components/InfoAndAuthBar";
import { quizCollection } from "../plugins/firebase";
import Settings from "../components/dashboard/Settings";
import { getPrimaryOrganization } from "@/constants/questions";

export const MENU_OPTIONS = {
  QUIZ_TEMPLATES: "Quizvorlagen",
  QUIZZES: "Durchgeführte Quizze",
  MEDIA: "Medienbibliothek",
  TRASH: "Papierkorb",
  SETTINGS: "Einstellungen"
}

export default {
  components: { Settings, InfoAndAuthBar, Mediathek, QuizCard },
  data() {
    return {
      MENU_OPTIONS,
    }
  },
  methods: {
    createQuizTemplate() {
      // todo: shorter ids
      quizCollection.add({
        name: "Unbenannte Quizvorlage",
        template: true,
        description: "",
        creator: this.$store.state.user.uid,
        organization: getPrimaryOrganization(this).id,
        questions: [],
        created: Date.now()
      });
    }
  },
  computed: {
    quizTemplates() {
      return this.$store.state.quiz.quizzes.filter(q => q.template && !q.deleted);
    },
    quizzes() {
      return this.$store.state.quiz.quizzes.filter(q => !q.template && !q.deleted);
    },
    trashedQuizzes() {
      return this.$store.state.quiz.quizzes.filter(q => q.deleted);
    },
    selected: {
      get() {
        return this.$store.state.selectedDashboardTab;
      },
      set(val) {
        return this.$store.commit("setSelectedDashboardTab", val);
      }
    }
  }
}
</script>